import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Trophy = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Trophy' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,15 C8.686,15 6,12.314 6,9 L6,1 L18,1 L18,9 C18,12.314 15.314,15 12,15 Z M6,3 L1,3 L1,7 C1,9.509 2.791,11 5,11 L6,11 L6,3 Z M18,11 L19,11 C21.209,11 23,9.509 23,7 L23,3 L18,3 L18,11 Z M5,23 L19,23 L19,19 L5,19 L5,23 Z M16,19 C16,16.790861 14.209139,15 12,15 C9.790861,15 8,16.790861 8,19' />
  </StyledIcon>
);
